import { render, staticRenderFns } from "./WallpaperManagementDetails.vue?vue&type=template&id=2d0c5386&scoped=true&"
import script from "./WallpaperManagementDetails.vue?vue&type=script&lang=js&"
export * from "./WallpaperManagementDetails.vue?vue&type=script&lang=js&"
import style0 from "./WallpaperManagementDetails.vue?vue&type=style&index=0&id=2d0c5386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c5386",
  null
  
)

export default component.exports